import CommandCenterChart from '../CommandCenterChart';
import useThemeVal from '../../../utility/useThemeVal';
import { Table, TableHead, TableRow, TableCell, TableBody, Box } from '@mui/material';
import { useState } from 'react';

export default function CropRunTab({ data , tableData , statusChoices,selectedStates, setSelectedStates, phaseDetails, onSubphaseClick,drawerData,viewBy, setViewBy, onSwitchToCommandView,routine,validate,alert }) {
  const currDarkThemeClass = useThemeVal();

  const plantKeyTitleMap = [
    { key: 'phase', title: 'Phase' },
    { key: 'harvest_count', title: 'Harvest Cnt' },
    { key: 'strain_count', title: 'Strain Cnt' },
    { key: 'plant_count', title: 'Plant Cnt' },
    { key: 'wet_weight', title: 'Wet Weight (lbs)' },
    { key: 'dry_weight_coef', title: 'Dry Weight Coef' },
    { key: 'price', title: 'Price ($)' },
    { key: 'rts_profit', title: 'RTS Profit' },
    { key: 'destroyed_plant_count', title: 'Destroyed Cnt' },
  ];
  const isDark = currDarkThemeClass === 'dark-theme';
  const theme = {
    text:         isDark ? '#FFFFFF' : '#1A1B19',
    textMuted:    isDark ? '#666666' : '#888888'
  };
  

  // Directly use the backend data for table entries
  const newTableEntries = tableData || [];
  const [isTableOpen, setIsTableOpen] = useState(true);

  const ccTableProps = {
    emptyTableMsg: 'No Data',
    tableTitles: plantKeyTitleMap,
    tableEntries: newTableEntries,
    toShowAddBtn: false,
    currDarkThemeClass,
  };
  

  const DisplayTable = ({ tableTitles, tableEntries, emptyTableMsg, currDarkThemeClass }) => {
    const getIconForName = name => {
      // Define a mapping of names to diamond colors
      const colorMap = {
        'In Pre Production': '#FFEC1F',
        'In Pre Harvest': '#D9FFBC',
        'In Pre Test': '#73DF12',
        'Finish Good Inventory': '#FF8A3C',
        'Sold Inventory': '#457DFF',
      };

      const diamondColor = colorMap[name] || '#D3D3D3'; // Default color if name is not found

      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="15"
          height="15"
          viewBox="0 0 15 15"
          fill="none"
          style={{
            marginRight: '8px',
            matrginLeft: '10px',
            borderRadius: '1px',
          }}
        >
          <g clipPath="url(#clip0_43_6347)">
            <rect
              x="7.07129"
              y="0.428955"
              width="10"
              height="10"
              rx="1"
              transform="rotate(45 7.07129 0.428955)"
              fill={diamondColor} // Set the color of the diamond itself
            />
          </g>
          <defs>
            <clipPath id="clip0_43_6347">
              <rect width="14.1421" height="14.1421" fill="white" transform="translate(0 0.428955)" />
            </clipPath>
          </defs>
        </svg>
      );
    };
    return (
      <Table
        className={currDarkThemeClass} // Apply the dark theme class
        aria-label="data table"
        sx={{
          '&.dark-theme': {
            backgroundColor: '#1e1e1e',
            color: '#fff', // Ensure table text color is white in dark mode
            marginX: '0px', // Adds margin to both left and right sides of the table
            backgroundColor: 'transparent', // Optional: Customize container background
          },
        }}
      >
        {/* Table Header */}
        <TableHead>
          <TableRow sx={{ height: '25px' }}>
            {' '}
            {/* Reduced header row height */}
            {tableTitles.map((title, index) => (
              <TableCell
                key={title.key}
                sx={{
                  fontWeight: 'bold',
                  fontSize: '1.1rem',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  borderBottom: '1px solid #414437',
                  padding: index === 0 ? '4px 20px 4px 4px' : '4px 4px 4px 4px', // Add extra padding to the first column (Phase)
                  borderRadius: index === 0 ? '10px 0 0 10px' : index === tableTitles.length - 1 ? '0 20px 20px 0' : 0, // Add border-radius to first and last headers
                  '&.dark-theme': {
                    backgroundColor: '#2E2F2D',
                    color: '#A1A591',
                  },
                  '&.light-theme': {
                    backgroundColor: '#D6E797',
                  },
                }}
                className={currDarkThemeClass}
              >
                {title.title}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        {/* Table Body */}
        <TableBody>
          {tableEntries.length > 0 ? (
            tableEntries.map((row, rowIndex) => (
              <TableRow
                key={rowIndex}
                className={currDarkThemeClass}
                sx={{
                  height: '40px', // Reduced row height
                  borderBottom: '1px solid #414437',
                  '&.dark-theme': {
                    backgroundColor: 'transparent',
                    '&:hover': {
                      backgroundColor: '#2f2f2f',
                    },
                  },
                }}
              >
                {row.map((cell, cellIndex) => (
                  <TableCell
                    key={cellIndex}
                    sx={{
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      fontSize: '1.1rem', // Reduced font size for compact rows
                      padding: '4px', // Reduced padding for cells
                      borderBottom: '1px solid #414437',
                      color:
                        cellIndex === 0
                          ? theme.text
                          : row[0] === 'In Pre Production' || row[0] === 'In Pre Harvest'
                          ? (cellIndex === 2 || cellIndex === 3) && row[0] === 'In Pre Harvest'
                            ? theme.text
                            : theme.textMuted
                          : row[0] === 'In Pre Test'
                          ? theme.text
                          : theme.text
                    }}
                    className={currDarkThemeClass}
                  >
                    {/* Render the icon for the first column only (e.g., name column) */}
                    {cellIndex === 0 && getIconForName(cell)}
                    {/* {cell} */}
                    {tableTitles[cellIndex].key === 'price' ? `$${cell}` : cell}
                  </TableCell>
                ))}
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell
                colSpan={tableTitles.length}
                className={currDarkThemeClass}
                sx={{
                  textAlign: 'center',
                  fontStyle: 'italic',
                  borderBottom: '1px solid #414437',
                  '&.dark-theme': {
                    color: '#888',
                  },
                }}
              >
                {emptyTableMsg}
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    );
  };

  return (
    <Box>
      <Box
        sx={{
          height: '87vh',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden'
        }}
      >

        {/* TABLE SECTION */}
        <Box sx={{ flexShrink: 0 }}>

          <Box
            onClick={() => setIsTableOpen(prev => !prev)}
            sx={{
              cursor: 'pointer',
              padding: '10px',
              color: theme.text,
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <span>Crop Summary Table</span>
            <span>{isTableOpen ? '▼' : '▶'}</span>
          </Box>

          {isTableOpen && (
            <DisplayTable {...ccTableProps} currDarkThemeClass={currDarkThemeClass} />
          )}

        </Box>

        {/* CHART SECTION */}
        <Box
          sx={{
            flex: 1,
            minHeight: 0,   // 🚨 THIS IS THE MAGIC LINE
            display: 'flex'
          }}
        >
          <CommandCenterChart
            data={data}
            statusChoices={statusChoices}
            currDarkThemeClass={currDarkThemeClass}
            selectedStates={selectedStates}
            setSelectedStates={setSelectedStates}
            onSubphaseClick={onSubphaseClick}
            drawerData={drawerData}
            viewBy={viewBy}
            setViewBy={setViewBy}
            onSwitchToCommandView={onSwitchToCommandView}
            routine={routine}
            validate={validate}
            alert={alert}
          />
        </Box>

      </Box>

    </Box>
  );
}
